// src/pages/LoginCallback.tsx
import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setTokens } from "src/utils/tokenCookie";

type TokenData = {
  tokenType: string;
  accessToken: string;
  refreshToken: string;
  userId: number;
  name: string;
  email: string;
};

type ApiResponse<T> = {
  statusCode: number;
  message: string;
  data: T;
};

export default function LoginCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const code = params.get("code");
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_OMS_SERVER_API}/v1/admin/auth/google/token`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
          }
        );

        if (!res.ok) throw new Error(`토큰 교환 실패 (${res.status})`);

        const json: ApiResponse<TokenData> = await res.json();

        // ✅ 여기서 성공/실패 판단 (너희 서버는 statusCode=1이 성공)
        if (json.statusCode !== 1) {
          throw new Error(json.message || "토큰 교환 실패");
        }

        const { accessToken, refreshToken } = json.data;
        if (!accessToken || !refreshToken) throw new Error("토큰이 비어있음");

        setTokens(accessToken, refreshToken);

        navigate("/", { replace: true });
      } catch (e) {
        console.error("LoginCallback error:", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [params, navigate]);

  return <div style={{ padding: 24 }}>로그인 처리 중...</div>;
}
